import styled from 'styled-components';
import {
  space,
  layout,
  color,
  typography,
  border,
  shadow,
  flexbox,
  position,
  compose
} from 'styled-system';
import shouldForwardProp from '@styled-system/should-forward-prop';

// Box with automatic prop filtering
export const Box = styled('div').withConfig({
  shouldForwardProp
})`
    box-sizing: border-box;
    ${compose(space, layout, color, typography, border, shadow, position)}
`;

// Flex inherits Box's filtering
export const Flex = styled(Box).withConfig({
  shouldForwardProp
})`
    display: flex;
    ${flexbox}
`;